<template>
  <b-modal
    ref="modal"
    title="Delete Files"
    centered
    @hide="closeHandler"
  >
    <template #modal-footer>
      <ButtonPrimary
        variant="primary"
        @click="accept"
      >
        Yes
      </ButtonPrimary>
      <ButtonOutline
        variant="outline-primary"
        @click="$refs.modal.hide()"
      >
        No
      </ButtonOutline>
    </template>

    <template v-if="isBriefLinkedFolder">
      This will unlink assets from the brief. Continue?
    </template>
    <template v-else>
      <p class="delete-modal-text">
        Are you sure you want to delete file <strong class="delete-modal-file-name">{{ name }}</strong>?
        <br>
        This action cannot be undone.
      </p>
    </template>
  </b-modal>
</template>

<script>
import ButtonPrimary from "../../../common/atoms/ButtonPrimary.vue";
import ButtonOutline from "../../../common/atoms/ButtonOutline.vue";
import mixinModal from './mixin'
import {createNamespacedHelpers} from "vuex";
import { isBriefLinkedFolder } from '../helpers';

const { mapGetters, mapActions } = createNamespacedHelpers('fileBrowser')
export default {
  name: "DeleteModal",
  components: {ButtonOutline, ButtonPrimary},
  mixins: [
    mixinModal
  ],
  props: {
    payload: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    name() {
      return this.payload?.name
    },
    isBriefLinkedFolder() {
      return isBriefLinkedFolder(this.payload);
    },
    briefTitle() {
      return this.payload?.brief_title || this.payload?.name;
    },
  },
  methods: {
    ...mapActions(['deleteById']),
    accept() {
      const payload = { ...this.payload };
      if (this.isBriefLinkedFolder) {
        payload.confirmBriefUnlink = true;
      }
      this.deleteById(payload);
    }
  }
}
</script>

<style scoped lang="scss">
.delete-modal-text {
  margin-bottom: 0;
}

.delete-modal-file-name {
  max-width: 100%;
  overflow-wrap: anywhere;
  word-break: break-word;
}
</style>